import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

export const OtherGroundProductsThanCementClassificationRow = ({
  material
}: {
  material: Material
}) => (
  <>
    <TableCell>
      <Typography variant="caption">{material.classification?.category}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.intermediateMillProduct}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">
        {material.classification?.referenceMeshSizeForResidue}
      </Typography>
    </TableCell>
  </>
)
